import { getGeoData, setGeoCookieIfNotExists } from "./geo";
import { loadInstantConfig } from "./instantConfig";
import { getDeviceType } from "./device";
import { cookieManager, processCommandQueue } from "utils";
import { Tracking } from "./tracking/track";
import { PrometheusTracker } from "./tracking/trackers/Prometheus/PrometheusTracker";
import { BeaconTracker } from "./tracking/trackers/Beacon/BeaconTracker";
import type { FandomHost } from "./types";
import { getVersion } from "./helpers/getVersion";
import { getBrowser } from "./browser";

(async () => {
  const app = window.ads?.context.platform ?? "app";
  const device = getDeviceType();
  const geo = await getGeoData(cookieManager);
  const browser = getBrowser();

  window.icbm = await loadInstantConfig(app, device, geo);
  window.dispatchEvent(new Event("instantConfigLoaded"));
  setGeoCookieIfNotExists(cookieManager, geo);

  // Add the fandom host information to the window
  window.fandomHost = {
    ...(window.fandomHost ?? {}),
    app,
    device,
    icbm: window.icbm,
    geo,
    version: getVersion(),
    browser,
  } satisfies FandomHost;

  window.fandomTrack = window.fandomTrack ?? { q: [] };
  new Tracking([new PrometheusTracker(), new BeaconTracker()]);

  // Process the command queue
  processCommandQueue(window.fandomHost);
})();
